import React from 'react';
import { useNavigate } from 'react-router-dom';
import icon from './images/ROSAFNewunscreen.gif';

function Rosaf() {
  const navigate = useNavigate();
  
  const handleNavigate = () => {
    navigate('/Opens');
  };

  const handleNavigate1 = () => {
    navigate('/Teachh');
  };

  const handleNavigateReport = () => {
    navigate('/displayname');
  };

  const handleNavigateDelete = () => {
    navigate('/delete');
  };

  const handleNavigateEdit = () => {
    navigate('/viewedit'); // Adjust the route to your "View/Edit" page
  };

  const userEmail = sessionStorage.getItem('userEmail');

  if (!userEmail) {
    navigate('/signin');
    return null;
  }
    
  return (
    <div 
      id="image-container" 
      style={{ 
        background: 'linear-gradient(to bottom, #fff7ad, #ffa9f9)', 
        minHeight: '100vh', 
        padding: '20px', 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', // Center align horizontally
      }}
    >
      {/* Header section */}
      <div 
        style={{ 
          display: 'flex', 
          alignItems: 'center', 
          marginBottom: '20px', 
          flexDirection: 'column', // Center heading and image vertically
        }}
      >
        <h2 
          className="center-heading" 
          style={{ 
            color: '#E11584', 
            fontSize: '55px', 
            marginBottom: '10px', // Space below the heading
            textAlign: 'center' // Center align heading text
          }}
        >
          ROSA F
        </h2>
        <img id="myimage" src={icon} alt="Rosafficonn" width="140" height="150" style={{ marginBottom: '20px' }} />
      </div>

      <p 
        style={{ 
          color: '#E11584', 
          fontSize: '20px', 
          textAlign: 'center', 
          marginBottom: '20px' 
        }}
      >
        Signed in as: {userEmail}
      </p>

      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      
      {/* Button section */}
      <div 
        className="button-container" 
        style={{
          display: 'flex', 
          flexDirection: 'column', // Stack buttons vertically
          alignItems: 'center', 
          justifyContent: 'center'
        }}
      >
        <button 
          className="button" 
          onClick={handleNavigate1} 
          style={{
            backgroundColor: '#E11584', 
            color: 'black', 
            padding: '15px 30px', 
            fontSize: '16px', 
            border: 'none', 
            borderRadius: '8px', 
            cursor: 'pointer', 
            margin: '10px',
            width: '200px' // Fixed width for equal-sized buttons
          }}
        >
          Teach
        </button>  

        <button 
          className="button" 
          onClick={handleNavigate} 
          style={{
            backgroundColor: '#E11584', 
            color: 'black', 
            padding: '15px 30px', 
            fontSize: '16px', 
            border: 'none', 
            borderRadius: '8px', 
            cursor: 'pointer', 
            margin: '10px',
            width: '200px' // Fixed width for equal-sized buttons
          }}
        >
          Open
        </button>
      
        <button 
          className="button" 
          onClick={handleNavigateReport} 
          style={{
            backgroundColor: '#E11584', 
            color: 'black', 
            padding: '15px 30px', 
            fontSize: '16px', 
            border: 'none', 
            borderRadius: '8px', 
            cursor: 'pointer', 
            margin: '10px',
            width: '200px' // Fixed width for equal-sized buttons
          }}
        >
          Report
        </button>

        {/* New View/Edit Button after Report Button */}
        <button 
          className="button" 
          onClick={handleNavigateEdit} 
          style={{
            backgroundColor: '#E11584', 
            color: 'black', 
            padding: '15px 30px', 
            fontSize: '16px', 
            border: 'none', 
            borderRadius: '8px', 
            cursor: 'pointer', 
            margin: '10px',
            width: '200px' // Fixed width for equal-sized buttons
          }}
        >
          View/Edit
        </button>

        {/* New Delete Button */}
        <button 
          className="button" 
          onClick={handleNavigateDelete} 
          style={{
            backgroundColor: '#E11584', // Pink color for the delete button
            color: 'black',  // Black text color
            padding: '15px 30px', 
            fontSize: '16px', 
            border: 'none', 
            borderRadius: '8px', 
            cursor: 'pointer', 
            margin: '10px',
            width: '200px' // Fixed width for equal-sized buttons
          }}
        >
          Delete
        </button>
      </div>
    </div>
  );
}

export default Rosaf;
